import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {DiscussionParticipantModel} from '../model/discussionParticipant.model';
import {Injectable} from '@angular/core';
import {UserSummaryConverter} from '../../../../../account/modules/user/api/converter/userSummary.converter';

@Injectable({
    providedIn: 'root'
})
export class DiscussionParticipantConverter extends HttpModelConverter<DiscussionParticipantModel> {
    protected createInstance(): DiscussionParticipantModel {
        return new DiscussionParticipantModel();
    }

    protected enrichObject(result: DiscussionParticipantModel, src: DiscussionParticipantModel) {
        result.user = new UserSummaryConverter().convert(src.user);
    }
}
